import React, { useEffect, useState } from "react";
import {
  getClientInvoiceBundle,
  createClientInvoiceBundle,
  getFileCategory,
} from "API/swesum";
import { useLoaderData, useNavigate } from "react-router-dom";

import usePost from "Hooks/usePost";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import ClientInvoiceBundleForm from "Components/ClientInvoiceBundle/ClientInvoiceBundleForm";
import { useClients } from "Context/Clients";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export async function loader() {
  const bundles = await getClientInvoiceBundle();
  const files = await getFileCategory("FAKTURABUNT");
  return { bundles, files };
}

const initialState = {
  File: "",
  InvoiceId: null,
  Status: "",
  Amount: "",
};

export function CreateClientInvoiceBundle() {
  const [formData, setFormData] = useState(initialState);
  const { files } = useLoaderData();
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const { openError } = usePopupNotificationContext();

  const createInvoiceReq = usePost({
    mtnFunc: (body) => createClientInvoiceBundle(body),
    onError: () => {
      openError("Ett fel uppstod när fakturan skapades.");
    },
    onSuccess: (data) => {
      navigate(`/clientinvoicebundle/${data.Id}`);
    },
  });

  useEffect(() => {
    if (!hasFetchedAll) {
      fetchClients();
    }
  }, []);

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography sx={{ marginBottom: "2rem" }} variant="h5">
              Skapa Fakturabunt
            </Typography>
            <ClientInvoiceBundleForm
              formData={formData}
              clients={clients}
              files={files}
              handleInputChange={handleInputChange}
            />
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                sx={{ ml: 3 }}
                onClick={() => createInvoiceReq.post(formData)}
                variant="contained"
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Box>
    </>
  );
}
